import Axios from 'axios'

const axiosEmailChecker = Axios.create({
  baseURL: process.env.VUE_APP_EMAIL_CHECKER_API_URL,
  timeout: 10000,
})

// A key shouldn't be required on production/whitelisted domains
if (process.env.VUE_APP_EMAIL_CHECKER_API_KEY) {
  axiosEmailChecker.defaults.params = {}
  axiosEmailChecker.defaults.params.key = process.env.VUE_APP_EMAIL_CHECKER_API_KEY
}

export default axiosEmailChecker
